// extracted by mini-css-extract-plugin
export var locationCard = "_i0-0";